<template>
	<reactive-base
      id="book-engine"
      app="astellas-nephro-books"
      testurl="https://search-springerhealthcaredev-diuqs74ej2l5d4hnevbtfhloui.eu-west-2.es.amazonaws.com"
      testurlapp="https://pHOmCz2Dt:5ba3d001-ae8c-4152-abdc-101e4fbe84b2@springerhealthcare-books-vhxzmms-arc.searchbase.io"
	    url="https://snproject8a7579dd.ew.r.appspot.com/"
	  >
		<nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom">
			<v-dialog name="offramp" ref="offramp" persistent />
			<div class="searchbar flex">
				<DataSearch
                  componentId="SearchText"
                  iconPosition="right"
                  :dataField="['bookDOI','chapterDOI','bookAboutText','bookEditors.EditorName.FamilyName.keyword','text','chapterAbstract','chapterFilterTerms.filterTerm','bookTitle','bookSubjectGroup.BookSubject' ]"
                  queryFormat="and"
				  :debounce="1500"
				  :highlight=false
				  className="data-search"
                  :showClear="true"
                  filterLabel="Searching for"
                  :autosuggest=true
                  placeholder="Search for books"
				  :react="{ and: ['Orderable', 'Subjects', 'Filters', 'Editors', 'PublishedYear', 'DoiSearch'] }"
				  />
				
				<DataSearch
					componentId="DoiSearch"
                	iconPosition="right"
					dataField="bookDOI"
					queryFormat="and"
					:customQuery="getCustomQuery"
					:defaultValue="filteredBookDoi"
					:debounce="1500"
					:highlight=false
					className="data-search"
					:showClear="true"
					filterLabel="DOI"
					placeholder="Search for Book DOI"
					:react="{ and: ['Orderable', 'Subjects', 'Filters', 'Editors', 'PublishedYear', 'SearchText'] }"
					style="display: none;"
				></DataSearch>
			</div>
			<!-- <button class="btn btn-primary" id="menu-toggle" style="margin-right:10px">{{ showBooks ? 'Show Filters' : 'Hide Filters' }}</button> -->
			<div class="filter-controls">
				<button class="toggle" @click="switchContainer">
					{{ showBooks ? 'Show Filters' : 'Hide Filters' }}
				</button>
				<SelectedFilters class="myfilters" :showClearAll=true  clearAllLabel="Clear filters"/>
			</div>
		</nav>
		<div class="d-flex" id="wrapper">
			<!-- Sidebar -->
			<div class="bg-light border-right" id="sidebar-wrapper" :class="{ hide: showBooks }">
				<div class="filters-container">
					<!--<multi-list
            id="order-section"
						componentId="Orderable"
						dataField="bookFlaggedForOrderable.keyword"
						class="filter order-section2"
						title="Available to order"
						:showSearch="false"
						:react="{ and: ['SearchText', 'Subjects', 'Filters','Authors','PublishedYear'] }"
					/>-->
					<multi-list
						:innerClass="{list: 'xyx'}"
						componentId="Subjects"
						dataField="bookSubjectGroup.BookSubject.keyword"
						class="filter filternoscroll"
						sortBy="asc"
						title="Categories"
						:showFilter="true"
						:size="1000"
						selectAllLabel="All categories"
						:react="{ and: ['SearchText', 'Filters','Editors', 'PublishedYear', 'Orderable', 'DoiSearch'] }"
					/>
					<multi-list
						componentId="Filters"
						dataField="chapterFilterTerms.filterTerm.keyword"
						class="filter filternoscroll"
						title="Topics"
						sortBy="asc"
						:size="1000"
						selectAllLabel="All filters"
						:react="{ and: ['SearchText', 'Subjects', 'Editors', 'PublishedYear', 'Orderable', 'DoiSearch'] }"
					/>
					<!-- <multi-list
						componentId="Authors"
						dataField="chapterExperts.creator.keyword"
						class="filter filternoscroll"
						title="Authors"
						sortBy="asc"
						selectAllLabel="All authors"
						:size="1000"
						:react="{ and: ['SearchText', 'Subjects', 'Filters', 'PublishedYear', 'Orderable', 'DoiSearch'] }"
					/> -->
					<multi-list
						componentId="Editors"
						dataField="bookEditors.EditorName.FamilyName.keyword"
						class="filter filternoscroll"
						title="Editors"
						sortBy="asc"
						selectAllLabel="All editors"
						:size="1000"
						:react="{ and: ['SearchText', 'Subjects', 'Filters', 'PublishedYear', 'Orderable', 'DoiSearch'] }"
					/>
					<range-slider  
						componentId="PublishedYear"
						dataField="bookPublishedYear"
						title="Published Year"
						:range='{
							start: 2015,
							end: 2022
						}'
						class="filter"
						:react="{ and: ['SearchText', 'Subjects', 'Filters', 'Editors', 'Orderable', 'DoiSearch'] }"

					/>
					<div class="c">
						<a class="menuoption" target="_blank" href="https://springerhealthcare.com/privacy-cookies/">Privacy and Cookies</a>
					</div>
					<div class="c">
						<img src="https://springerhealthcare.com/wp-content/uploads/thegem-logos/logo_134d4b66f5f2b65ab331ba75e0caa571_1x.png" srcset="https://springerhealthcare.com/wp-content/uploads/thegem-logos/logo_134d4b66f5f2b65ab331ba75e0caa571_1x.png 1x, https://springerhealthcare.com/wp-content/uploads/thegem-logos/logo_134d4b66f5f2b65ab331ba75e0caa571_2x.png 2x, https://springerhealthcare.com/wp-content/uploads/thegem-logos/logo_134d4b66f5f2b65ab331ba75e0caa571_3x.png 3x" alt="Springer Healthcare" class="SHClogoImage">
					</div>
				</div>
			</div>
			<!-- /#sidebar-wrapper -->
			<!-- Page Content -->
			<div id="page-content-wrapper">
				<div class="container-fluid">
					<div class="result-list-container">
						<!--
						<div class="filter-controls"><button class="toggle" @click="switchContainer">
								{{ showBooks ? 'Show Filters' : 'Hide Filters' }}
							</button><SelectedFilters class="myfilters" showClearAll={true} clearAllLabel="Clear filters"/></div>
						-->
						<reactive-list
							componentId="SearchResult"
							dataField="original_title.keyword"
							className="result-list"
							paginationAt="both"
							:pagination="true"
							:pages="10"
							:size="3"
							:class="{ full: showBooks }"
							:infiniteScroll="false"
							:innerClass="{pagination:'mypagi'}"
							:react="{ and: ['Orderable', 'SearchText', 'Filters', 'PublishedYear', 'Editors', 'Subjects', 'DoiSearch'] }"
						>
							<book-display-panel  slot="renderItem" class="renderItem" slot-scope="{ item }" v-bind="item" />
						</reactive-list>
					</div>
				</div>
			</div>
			<!-- /#page-content-wrapper -->
		</div>
		<!-- /#wrapper -->
	</reactive-base>
</template>

<style>
	.mypagi{
	text-align: left;
	}

	.XXXfilternoscroll ul{
		overflow-y: visible;
		max-height: none;
	}

	.filters-container{
		overflow-y: visible;
		max-height: none;
	}

	/* .v--modal-overlay {
	background: red;
	} */

	/* .v--modal-box{
		top:40%;
	} */

</style>

<script>
import './../styles.css';
//import './../styles2.css';
import BookDisplay from './BookDisplayPanel'

//show();
//this.$modal.show('hello-world', { foo: 'bar' })
// methods: {
//   show () {
//     this.$modal.show('hello-world');
//   },
//   hide () {
//     this.$modal.hide('hello-world');
//   }
// }

export default {
    name: 'app',
    data: function() {
        return {
            showBooks: window.innerWidth <= 768 ? true : false,
            observer: null,
			filteredBookDoi: ''
        };
    },
    beforeMount() {
      // Everytime the height of book e-lib component is changed, it will post a message to parent
      this.observer = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const cr = entry.contentRect
          const elementObjSize = {
			dataType: 'height',
            data: {
				width: Math.ceil(cr.width),
				height: Math.ceil(cr.height),
				unit: 'px'
			}
          }
          window.parent.postMessage(elementObjSize, '*')
        })
      })
	  this.filterByBookDoi();
    },
    mounted() {
		const bookEngineArea = document.getElementById('book-engine')
		this.observer.observe(bookEngineArea)
		this.addBannerToBook()
		// this.addBanner();
    },
    methods: {
        switchContainer: function() {
            return (this.showBooks = !this.showBooks);
        },
        orderBook: function() {
            alert('Book order processing available after integration with user database', 'Feature not fully implemented');
        },
        show() {

		    },
        hide() {
            this.hide();
        },
        show_dialog(theUrl, srcComponent) {

            var xPos = $("#myButton").offset().left;
            var yPos = $("#myButton").offset().top;

            this.$modal.show('dialog', {
                text: 'You are leaving this site to navigate to an external website.  We invite you to read its Privacy Policy',
                buttons: [{
                        title: 'I AGREE',
                        handler: () => {
                            window.open(theUrl)
                            dialog: false
                        }
                    },
                    {
                        title: 'CANCEL'
                    }
                ],
                pivotX: 1,
                pivotY: 1,
                position: {
                    x: xPos,
                    y: yPos
                }
            });
            this.$refs.offramp.width = "1000px"
            console.log(this.$refs.offramp)
        },
        addBannerToBook() {
            var _this = this;
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    for (var i = 0; i < mutation.addedNodes.length; i++) {
                        var node = mutation.addedNodes[i]
                        if (node.id === 'order-section') {
                            _this.addBanner()
                        }
                    }
                })
            })

            observer.observe(document.body, {
                childList: true
                , subtree: true
                , attributes: false
                , characterData: false
            })
        },
        addBanner() {
          var orderSectionEle = document.getElementById('order-section')
          var bannerEle = document.createElement('div');

          bannerEle.classList.add('banner-layout');
          
          var bannerDetail = document.createElement('div');
          bannerDetail.innerHTML = 'Selected books are available for order in print';
          bannerDetail.classList.add('banner-detail')

          // Prepend section
          bannerEle.appendChild(bannerDetail);
          orderSectionEle.prepend(bannerEle);
        },
		filterByBookDoi() {
			const query = this.$route.query;
			if ('filterbook' in query) {
				this.filteredBookDoi = query.filterbook;
			}
		},
		getCustomQuery(value, props) {
			// console.log(value, props);
			if (value) {
				return {
					query: {
						bool: {
							should: [
								{
									"multi_match": {
										"query": value,
										"fields": [
											props.dataField
										],
										"type": "cross_fields",
										"operator": "and"
									}
								},
								{
									"multi_match": {
										"query": value,
										"fields":[
											props.dataField
										],
										"type":"phrase",
										"operator":"and"
									}
								},
								{
									"multi_match":{
										"query": value,
										"fields": [
											props.dataField
										],
										"type": "phrase_prefix",
										"operator": "and"
									}
								}
							],
							"minimum_should_match": "1"
						}
					}
					// ,
					// sort: [
					// 	{
					// 		"chapterNum": {
					// 			"order": "asc"
					// 		}
					// 	}
					// ]
				};
			} else {
				return {}
			}
		}
    },
    watch: {

    }
};
</script>

<style lang="css">
#order-section .banner-layout {
  background-color: #3c9343;
  padding: 5px 2px;
  margin-bottom: 12px;
}
#order-section .banner-detail {
  text-align: center;
  color: white;
}
</style>